import { connect } from 'react-redux';
import { registerBanner, deregisterBanner, hideBanner } from './Banner.reducer';
import Banner from './Banner';
import { selectBannerInfo } from './Banner.selectors';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const { type, messageProps, targetId } = selectBannerInfo(state);

  return {
    ...ownProps,
    type,
    messageProps: id === targetId ? messageProps : null,
  };
};

const mapDispatchToProps = { registerBanner, deregisterBanner, hideBanner };

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
